//Author June Leow
//Date Mar 25th, 2024
import {Card, CardHeader, CardBody} from 'reactstrap';
import Utilities from './utilities';
import Ancillary from './ancillary'
import StepPhoto from './step-photo'
import React, {useEffect} from 'react';

const StepUtilyAncillary  = (props)=>{
  const controller = new AbortController();

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state

  //API call
  
  //render
  return <div>
    <Card>
      <CardHeader className="header-color">Utility</CardHeader>
      <CardBody>
        <Utilities {...props}/>
      </CardBody>
    </Card>
    <br/>
    <Card>
    <CardHeader className="header-color">Ancillary</CardHeader>
    <CardBody>
      <Ancillary {...props}/>
      <StepPhoto {...props}/>
    </CardBody>
  </Card>
  </div>
}


export default StepUtilyAncillary;
